import {getConfigItem, configConstants} from '@servicenow/ui-config';

const {PAGE_OPT_OUT_PROPERTY_DEEP_COMPARE, PAGE_OPT_OUT_STATE_DEEP_COMPARE} = configConstants;
const propertyOptOutPages = (getConfigItem(PAGE_OPT_OUT_PROPERTY_DEEP_COMPARE) || '').split(',');
const stateOptOutPages = (getConfigItem(PAGE_OPT_OUT_STATE_DEEP_COMPARE) || '').split(',');

export default function shouldOptOutOfDeepCompareForPage(type) {
	const pages = type === 'property' ? propertyOptOutPages : stateOptOutPages;
	return pages.find(page => window.location.href.includes(page));
}
